import React, { useRef, useEffect } from "react"
import Script from "next/script"
import { FlourishProps, WindowWithVisuals } from "./types"

const FlourishChart: React.FC<FlourishProps> = ({ storyId, width }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const isLongId = storyId.length === 8 // for Detroit story
  const embedType = isLongId ? "visualisation" : "story"

  function getWindow(): WindowWithVisuals {
    return window as WindowWithVisuals
  }

  useEffect(() => {
    // load if not already loaded
    const loadFlourishScript = () =>
      new Promise<void>((resolve) => {
        const windowWithVisuals = getWindow()
        if (windowWithVisuals.visuals) {
          resolve()
          return
        }
        const script = document.createElement("script")
        script.src = "https://public.flourish.studio/resources/embed.js"
        script.onload = () => resolve()
        document.head.appendChild(script)
      })

    const loadChart = async () => {
      if (!chartRef.current) return

      chartRef.current.innerHTML = ""

      const windowWithVisuals = getWindow()
      windowWithVisuals.FlourishLoaded = false

      await loadFlourishScript()

      if (windowWithVisuals.visuals?.loadEmbed) {
        await windowWithVisuals.visuals.loadEmbed(`${embedType}/${storyId}`)
      }
    }

    loadChart()

    return () => {
      if (chartRef.current) chartRef.current.innerHTML = ""
    }
  }, [storyId])

  return (
    <>
      <Script src="https://public.flourish.studio/resources/embed.js" strategy="lazyOnload" />
      <div className="flex w-full items-center justify-center">
        <div
          ref={chartRef}
          className={`${width} flourish-embed max-w-6/12 mx-auto`}
          data-src={`${embedType}/${storyId}`}
        />
      </div>
    </>
  )
}

export default FlourishChart
